import React from 'react';
import { Modal } from 'antd';
import DebtDetailComponent from './DebtDetailComponent';

interface DebtDetailModalProps {
  isOpen: boolean;
  onClose: () => void;
  debtId: string | null;
  onPrint?: () => void;
  onConfirm?: () => void;
}

const DebtDetailModal: React.FC<DebtDetailModalProps> = ({ isOpen, onClose, debtId, onPrint, onConfirm }) => {
  if (!debtId) return null;

  return (
    <Modal
      open={isOpen}
      onCancel={onClose}
      footer={null}
      width={1800}
      destroyOnClose={true}
      bodyStyle={{ padding: 0 }}
      closeIcon={false}
      centered
      className='modal-none-padding max-h-[100vh] overflow-y-auto'
    >
      <DebtDetailComponent debtId={debtId} onClose={onClose} onPrint={onPrint} onConfirm={onConfirm} />
    </Modal>
  );
};

export default DebtDetailModal;
